import React, { useState } from 'react';
import { AddAppointment, Container1, Container2, BoxContainer, BoxInner1, InnerAppointments, Text, Texts, Text2, DataContainer, StatusData, LineContainer, MenuContainer, PagingContainer, InnerBox } from './Styles';
import { ReactComponent as Add } from '../../../../../../src/assets/images/add-square.svg';
import InputSelect from 'src/components/shared/Form/Select';
import { ReactComponent as MenuIcon } from '../../../../../assets/images/more.svg';
import Paging from 'src/components/App/Paging';
import { Box } from '@mui/material';
import NoDataFound from '../../NoDataFound/NoDataFound';
import PrescriptionTabForm from '../Forms/PrescriptionTabForm';
import DialogBox from 'src/components/shared/Dialog/DialogBox';

const PrescriptionCard = ({ prescription = [], page, perPage, setPage, totalCount }) => {
    const data = prescription.map((prescriptionData) => ({
        prescriptionId: prescriptionData?.id,
        note: prescriptionData?.notes,
        addedDate: new Date(prescriptionData.date).toLocaleDateString('en-GB', {
            day: '2-digit', month: 'short', year: 'numeric'
        }) + `, ${prescriptionData.time}`,

    }))
    return (
        <>
            <Container2>
                <InnerAppointments>
                    <InnerBox isEmpty={data.length === 0}>
                        {data.length === 0 ? (
                            <NoDataFound
                                title="No Prescription Found!"
                                showButton={false}
                                description="No prescriptions recorded by the doctor for this patient yet."
                            />

                        ) : (
                            <>
                                {data.map((item) => (
                                    <BoxContainer key={item.prescriptionId}>
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text2 style={{ whiteSpace: 'pre-wrap' }}>{item.note}
                                                </Text2>

                                            </DataContainer>

                                        </BoxInner1>
                                        <LineContainer />
                                        <BoxInner1>
                                            <DataContainer>
                                                <Text>{item.addedDate}</Text>
                                                <Texts>Date & Time</Texts>
                                            </DataContainer>
                                            <MenuContainer>
                                                <MenuIcon />
                                            </MenuContainer>
                                        </BoxInner1>
                                    </BoxContainer>
                                ))}
                            </>
                        )}


                    </InnerBox>
                    <PagingContainer>
                        <Paging
                            page={page}
                            perPage={perPage}
                            count={totalCount || 0}
                            onChange={(newPage) => setPage(newPage)}
                        />
                    </PagingContainer>

                </InnerAppointments>
            </Container2>
        </>
    )
}

export default PrescriptionCard
